import { Component, Fragment } from "react";
import { CollectionProps } from "react-virtualized";
import classNames from "classnames";
import Checkbox from "@sdkit/checkbox";

type Props = CollectionProps & {
  expandedRows?: any[];
  selectedRows?: any[];
};

export class RowRenderer extends Component<Props> {
  static defaultProps = {
    expandedRows: [],
    selectedRows: [],
  };
  handleSelect = (e) => {
    const { rowData, onSelect } = this.props;
    const isSelected = e.target.checked;
    onSelect({ selectedRow: rowData, isSelected });
  };

  handleRowClick = (e) => {
    const { rowData, index, onRowClick } = this.props;
    onRowClick({ rowData, index });
  };

  render() {
    const { handleSelect, handleRowClick } = this;
    const {
      className,
      columns,
      index,
      style,
      rowData,
      rowHeight,
      expandedRowHeight,
      selectedRows,
      isSelectable,
      expandedRows,
      expandableContent,
      getRowKey,
    } = this.props;

    const isEqualToRowData = (selectedRowData) => {
      if (getRowKey) {
        return getRowKey(selectedRowData) === getRowKey(rowData);
      } else {
        return Object.is(selectedRowData, rowData);
      }
    };

    const isSelected = selectedRows!.some(isEqualToRowData);
    const isExpanded = expandedRows!.some(isEqualToRowData);

    return (
      <Fragment>
        <div
          role="row"
          style={{
            ...style,
            height: rowHeight,
            willChange: "top",
            transition: "top .3s",
          }}
          className={classNames([
            className,
            index % 2 && "odd",
            isSelected && "selected",
          ])}
          onClick={handleRowClick}
        >
          {isSelectable && (
            <div
              className="ReactVirtualized__Table__rowColumn"
              style={{ flexShrink: 0 }}
            >
              <Checkbox checked={isSelected} onChange={handleSelect} />
            </div>
          )}

          {columns}
        </div>

        <div
          style={{
            overflow: "hidden",
            position: "absolute",
            top: style!.top + rowHeight,
            width: "100%",
            height: isExpanded ? expandedRowHeight : 0,
            willChange: "top, height",
            transition: "top .3s, height .3s",
          }}
        >
          {isExpanded && expandableContent({ rowData })}
        </div>
      </Fragment>
    );
  }
}
